const EVENT_SERVICE_BASE = "/gateway/api/event-service"

export const API_ADD_EVENT = `${EVENT_SERVICE_BASE}/events/add`
export const API_GET_LIST_EVENT = `${EVENT_SERVICE_BASE}/events`
export const API_GET_LIST_EVENT_EMBED = `${EVENT_SERVICE_BASE}/events/list-embed`
export const API_GET_DETAIL_EVENT = `${EVENT_SERVICE_BASE}/events`
export const API_ADD_GET_DETAIL_EVENT = `${EVENT_SERVICE_BASE}/events-add`
export const API_UPDATE_EVENT = `${EVENT_SERVICE_BASE}/events`
export const API_DELETE_EVENT = `${EVENT_SERVICE_BASE}/events`
export const API_UPDATE_CHECK_IN_EVENT = `${EVENT_SERVICE_BASE}/user-event`
export const API_GET_LIST_USER_EVENT = `${EVENT_SERVICE_BASE}/user-event/list-user`
export const API_ADD_USER_EVENT = `${EVENT_SERVICE_BASE}/user-event/add`
export const API_DELETE_USER_EVENT = `${EVENT_SERVICE_BASE}/user-event`
export const API_GET_DETAIL_USER_EVENT = `${EVENT_SERVICE_BASE}/user-event`
export const API_GET_LIST_DELETE_EVENT = `${EVENT_SERVICE_BASE}/events/deleted`
export const API_RESTORE_EVENT = `${EVENT_SERVICE_BASE}/events/restore`
export const API_PUBLISH_EVENT = `${EVENT_SERVICE_BASE}/events/publish`
export const API_GET_LIST_SHARE_EVENT = `${EVENT_SERVICE_BASE}/events/list-share`
export const API_SEND_EMAIL_REGISTER_EVENT = `${EVENT_SERVICE_BASE}/send-email`
export const API_SEND_EMAIL_CREATE_EVENT = `${EVENT_SERVICE_BASE}/send-email/admin`
export const API_UPLOAD_EXCEL = `${EVENT_SERVICE_BASE}/events/upload-excel`
export const API_INVITE_EMAIL = `${EVENT_SERVICE_BASE}/send-email/invites`
